import { createSelector } from 'reselect';
import { getPageData } from 'src/universal/redux/page';

export const getThreeUpData = createSelector([getPageData], pageData => {
  return pageData.businessHubProductTiles;
});
